// extracted by mini-css-extract-plugin
export default {"variables":"\"variables.css\"","first-table-shrink-width":"1050px","header":"AuthTopBar_header__+nUNz","logo":"AuthTopBar_logo__Ad6T9"};